<div class="row g-4">
    @if (access.attendance) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Attendance Score">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [employeeId]="userIds.attendance"
                    [loadData]="loadAttendance"
                    [palette]="palettes.attendance"
                    [noDataExclude]="attendanceTimeOffTypes"
                    centerText="My Score"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.efficiency) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Overall Efficiency">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadEfficiency"
                    [palette]="palettes.efficiency"
                    centerText="Efficiency"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.checklistCompliance) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="MHE Checklist Compliance">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [employeeId]="userIds.checklistCompliance"
                    [loadData]="loadChecklistCompliance"
                    [palette]="palettes.checklistCompliance"
                    centerText="My Score"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.checklistCondition) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="MHE Condition Status">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [employeeId]="userIds.checklistCondition"
                    [loadData]="loadChecklistCondition"
                    [palette]="palettes.checklistCondition"
                    centerText="My Score"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.incidentReports) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Safety Incidents">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [employeeId]="userIds.incidentReports"
                    [loadData]="loadIncidents"
                    [palette]="palettes.incidentReports"
                    centerText="Incidents"
                    formatMode="decimal"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Safety Observations">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [employeeId]="userIds.incidentReports"
                    [loadData]="loadObservations"
                    [palette]="palettes.incidentReports"
                    centerText="Observations"
                    formatMode="decimal"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }
</div>
